import {Component, Input, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';

@Component({
    selector: 'app-free-adv',
    templateUrl: './free-adv.component.html',
    styleUrls: ['./free-adv.component.css'],
    standalone: false
})
export class FreeAdvComponent implements OnInit {

  @Input() dialogRef:any;
  constructor(private modalService: MatDialog) { }

  ngOnInit(): void {
  }


  closeDialog() {
    this.modalService.closeAll();
  }
}
